import { makeQuery } from 'shared/utilities';

export const outlookDisconnectQuery = async function () {
    return await makeQuery<{}>('/outlook/disconnect', {
        method: 'post'
    });
}
